/**
 * The path to go to after signing in (specs/12 FR-81): `next` when it's a path on this site,
 * otherwise "/". Anything that could leave the site (`//host`, `/\host`, `https:`,
 * `javascript:`) is refused.
 */
export function safeNext(next: string | null | undefined): string {
  if (!next || next[0] !== "/") return "/";
  if (next[1] === "/" || next[1] === "\\") return "/";
  // Browsers ignore tabs and newlines in URLs, so "/\t/host" would become "//host".
  if (next.includes("\\") || [...next].some((c) => c < " ")) return "/";
  return next;
}
